import { useTranslation } from 'react-i18next'
import { Accordion } from '@/components'
import { ServicesContent } from './ServicesContent'

export function MobileServicesAccordion() {
  const { t } = useTranslation()

  return (
    <Accordion
      title={t('sidebar.moreSignatures.title')}
      className='lg:hidden w-full'
      buttonClassName='text-cencert-header-blue font-semibold'
      contentClassName='bg-white'
    >
      <ServicesContent
        showTitle={false}
        serviceCardContainerClassName='bg-cencert-bg-gray'
      />
    </Accordion>
  )
}
